import { atom } from 'jotai';


export enum NavigationStateEnum {
  Default = 'default',
  MobileMenuOpen = 'MobileMenuOpen',
  SearchMenuOpen = 'SearchMenuOpen',
  StationMenuOpen = 'StationMenuOpen',
  UserMenuOpen = 'UserMenuOpen',
}

export const navigationAtom = atom(NavigationStateEnum.Default);
